// extracted by mini-css-extract-plugin
export default {"ClientProfilesPage":"ClientProfilesPage_ClientProfilesPage__U3V3i","icon":"ClientProfilesPage_icon__WwShH"};